import { use } from 'react';
import { isBlocked } from '../components/plans/plan-locks.js';
import { useEntitlements } from '../hooks/api/use-plans.js';
import { useSuspension } from '../hooks/use-suspension.js';
import { AuthContext } from '../lib/auth-context.js';

export type OnboardingScope = 'pending' | 'in' | 'out';

/**
 * La mise en route ne vit que dans un cabinet ouvert : ni assistant, ni liste, ni visite pour un
 * cabinet bloqué ou suspendu — l'équipe de la plateforme, qui y entre malgré le blocage, ne doit
 * pas y être accueillie comme un nouveau membre. Sans cabinet actif, rien à demander au serveur.
 * `pending` tant que l'offre n'est pas lue : on ne sait pas encore si le cabinet est bloqué.
 */
export function useOnboardingScopeState(): OnboardingScope {
  const auth = use(AuthContext);
  const entitlements = useEntitlements({ enabled: auth !== null });
  const suspension = useSuspension();
  const organization =
    auth?.organizations.find((item) => item.id === auth.activeOrganizationId) ?? null;
  if (organization === null || suspension !== null) return 'out';
  if (entitlements.isPending) return 'pending';
  if (entitlements.isError || isBlocked(entitlements.data)) return 'out';
  return 'in';
}

export function useOnboardingScope(): boolean {
  return useOnboardingScopeState() === 'in';
}
